var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React from 'react';
import styles from './StyledDialog.module.css';
var StyledDialogAppBar = /** @class */ (function (_super) {
    __extends(StyledDialogAppBar, _super);
    function StyledDialogAppBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyledDialogAppBar.prototype.render = function () {
        var _a;
        var _b = this.props, titleBarLeft = _b.titleBarLeft, titleBarRight = _b.titleBarRight, title = _b.title, headerExtraContents = _b.headerExtraContents, children = _b.children, hasStepper = _b.hasStepper, hasTabs = _b.hasTabs, otherProps = __rest(_b, ["titleBarLeft", "titleBarRight", "title", "headerExtraContents", "children", "hasStepper", "hasTabs"]);
        var appBarClass = classNames(styles.appBar, (_a = {},
            _a[styles.hasStepper] = this.props.hasStepper,
            _a[styles.hasTabs] = this.props.hasTabs,
            _a));
        if (!!title || !!titleBarRight || !!titleBarLeft || !!headerExtraContents)
            return (React.createElement(AppBar, __assign({}, otherProps, { position: 'static', color: 'primary', elevation: 0, className: appBarClass }),
                React.createElement(Toolbar, null,
                    React.createElement(Grid, { container: true, direction: 'row', alignItems: 'center' },
                        titleBarLeft && React.createElement(Grid, { item: true }, titleBarLeft),
                        React.createElement(Grid, { item: true, xs: true },
                            React.createElement(Typography, { variant: 'h6', color: 'inherit' }, title)),
                        titleBarRight && React.createElement(Grid, { item: true }, titleBarRight))),
                headerExtraContents,
                children));
        return null;
    };
    StyledDialogAppBar.muiName = 'AppBar';
    return StyledDialogAppBar;
}(React.Component));
export { StyledDialogAppBar };
